import React from 'react';
import WebLayout from '../layouts/WebLayout';

const StudentBenefitPage = () => {
    return (
        <WebLayout>
            <div className="min-h-screen bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                    {/* 메인 타이틀 */}
                    <div className="text-center mb-20">
                        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                            학교 근처 식당, <span className="text-amber-500">학생이라면 더 싸게!</span>
                        </h1>
                    </div>

                    {/* 1행 - 학교 근처 제휴 매장 */}
                    <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                        <div className="space-y-6">
                            <h2 className="text-3xl font-bold text-amber-500">학교 근처 제휴 매장 우선 제공</h2>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                밥친구는 학교 근처 식당부터 우선 제휴해요<br/>
                                그래서 집 앞, 도서관 옆, 동아리 방 옆 맛집들도<br/>
                                밥친구 앱에서 바로 만나볼 수 있어요.
                            </p>
                        </div>
                        <div className="aspect-[4/3] rounded-lg overflow-hidden">
                            <img 
                                src="/images/web2_1.png" 
                                alt="학교 근처 제휴 매장 이미지" 
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    {/* 2행 - 학생증 인증 혜택 */}
                    <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                        <div className="space-y-6">
                            <h2 className="text-3xl font-bold text-amber-500">학생증 인증 시 추가 혜택</h2>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                학생증 인증만 하면,<br/>
                                제휴된 매장에서만 제공하는 추가 혜택도 있어요!
                            </p>
                        </div>
                        <div className="aspect-[4/3] rounded-lg overflow-hidden">
                            <img 
                                src="/images/web2_2.png" 
                                alt="학생증 인증 혜택 이미지" 
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    {/* 3행 - 학교 중심 모임 */}
                    <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                        <div className="space-y-6">
                            <h2 className="text-3xl font-bold text-amber-500">학교 중심 모임</h2>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                학생들끼리 자주 가는 맛집,<br/>
                                점심시간이면 열리는 소모임까지.
                            </p>
                        </div>
                        <div className="aspect-[4/3] rounded-lg overflow-hidden">
                            <img 
                                src="/images/web2_3.png" 
                                alt="학교 중심 모임 이미지" 
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </WebLayout>
    );
};

export default StudentBenefitPage; 